export const NAV_LINKS = [
  { label: 'System', href: '#system' },
  { label: 'Rewards', href: '#rewards' },
  { label: 'Bali', href: '#bali' },
  { label: 'FAQ', href: '#faq' },
];

export const TELEGRAM_URL = 'https://t.me/mbealert';

export const MBE_LOGO_URL = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/pehnici6_PROFILE%20MBE%20INTERNATIONAL%20OREN%202.webp';

export const MENTOR = {
  name: 'Zack',
  role: 'Founder of MBE International',
  quote: 'I built this ecosystem so you can trade with institutional clarity. Your only job is to execute.',
  image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/ulxb3kvi_AIMAN%20BASE%20PHOTO.jpg',
};

export const PILLARS = [
  {
    icon: 'brain',
    title: 'Premium Education & Masterclasses',
    desc: 'Weekly live webinars where Zack breaks down the exact High Volume Blueprint. Learn how to stack lots safely without over leveraging your account.',
    tag: 'Live Weekly Webinar',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/xr4xlxbi_LIVE%20WEBINAR%20MBE%20ALERT%20%281%29.jpg',
  },
  {
    icon: 'zap',
    title: 'High Probability Trading Signals',
    desc: 'Stop staring at charts 24/7. Our analyst team pushes clean Silver (XAGUSD) setups to your phone with entry, SL and TP already prepared.',
    tag: 'Delivered on Telegram',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/toy1phue_daily%20signal.webp',
  },
  {
    icon: 'chart',
    title: 'Proprietary MBE Indicator',
    desc: 'Exclusive MBE indicator built to detect Support, Resistance and Trend Reversal zones with high accuracy. Your second pair of eyes on the chart.',
    tag: 'Precision Tool',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/k38q00w6_mbe%20indicator.jpg',
  },
  {
    icon: 'bell',
    title: 'Real Time MBE Alert System',
    desc: 'Instant push alerts the moment the market enters critical Buy or Sell zones so you never miss a golden entry, even when you are busy.',
    tag: 'Instant Push Alert',
    image: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_trader-mirror-site/artifacts/lkfxfv4e_MBE%20ALERT%20PNG.webp',
  },
];

export const HERO_STATS = [
  { value: 'USD 200', label: 'Cash Bonuses Unlocked' },
  { value: '30 Lots', label: 'Silver to Bali' },
];

export const STEPS = [
  {
    n: '01',
    title: 'Register for Free',
    desc: 'Verify your existing or dormant MBE Live Trading Account. Registration takes less than 60 seconds.',
  },
  {
    n: '02',
    title: 'Trade Silver Only',
    desc: 'Open your Silver (XAGUSD) trades and accumulate your lots. Only Silver volume counts toward your target.',
  },
  {
    n: '03',
    title: 'Collect Weekly Cash',
    desc: 'Track your name on the open Weekly Leaderboard and withdraw your cash bonuses the moment you hit each milestone.',
  },
];

export const ECOSYSTEM_STATS = [
  { icon: 'users', value: '5,200+', label: 'Silver Traders Community' },
  { icon: 'award', value: '18 Mo', label: 'Track Record on Silver Desk' },
  { icon: 'trend', value: '92%', label: 'Members Trade Silver Weekly' },
];

export const FEATURE_CARDS = [
  {
    icon: 'zap',
    tag: 'Delivered on Telegram',
    title: 'Daily Silver Setups & Signals',
    desc: 'Our analyst desk drops high probability Silver (XAGUSD) setups and signals daily. No chart staring. You get pair, entry, SL and TP already structured so you enter with confidence.',
    image: 'https://images.unsplash.com/photo-1615992174118-9b8e9be025e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjB0cmFkaW5nfGVufDB8fHx8MTc4NDI3MzA3MHww&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: 'graduation',
    tag: 'The High Volume Blueprint',
    title: 'Weekly Silver Masterclass',
    desc: 'Learn the exact Silver risk management and compounding strategies used by top 1% traders. Live weekly sessions teach you how to grow lot counts safely without over leveraging or blowing your account.',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzaWx2ZXIlMjB0cmFkaW5nJTIwY2hhcnR8ZW58MHx8fHwxNzg0MjczMDcxfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    icon: 'grid',
    tag: 'Real Time Progress',
    title: 'Personal Lot Tracker Dashboard',
    desc: 'Know exactly where you stand. A private dashboard updates your Silver lot progress live. No manual counting. Milestones and unlocked cash rewards displayed transparently every minute.',
    image: 'https://images.unsplash.com/photo-1612178991541-b48cc8e92a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtb2JpbGUlMjB0cmFkaW5nfGVufDB8fHx8MTc4NDI3MzA3MHww&ixlib=rb-4.1.0&q=85',
  },
];

export const SILVER_ADVANTAGES = [
  {
    icon: 'zap',
    title: 'High Volatility. Fast Lots.',
    desc: 'Silver moves with wide daily pip ranges. That is why smart traders generate lot volume quickly with short term, strategic Silver trades.',
  },
  {
    icon: 'chart',
    title: 'Clean Chart Patterns',
    desc: 'Silver respects support and resistance levels beautifully. Highly readable technical structure makes entries easier to plan and execute.',
  },
  {
    icon: 'scale',
    title: 'Maximum Margin Efficiency',
    desc: 'With flexible leverage on Silver, you can open larger contract sizes using a very small margin. Grow your lot count safely without risking your whole account.',
  },
];

export const MILESTONES = [
  {
    tag: 'Milestone 1',
    lots: '10 Silver Lots',
    reward: 'USD 100 Cash',
    note: 'Credited directly to your account.',
    cumulative: 'USD 100',
  },
  {
    tag: 'Milestone 2',
    lots: '20 Silver Lots',
    reward: 'USD 100 Cash',
    note: 'Total collected: USD 200.',
    cumulative: 'USD 200',
  },
  {
    tag: 'Milestone 3',
    lots: '30 Silver Lots',
    reward: 'BALI VACATION TRIP',
    note: 'Fully sponsored premium getaway.',
    cumulative: 'USD 200 + Bali',
    isFinal: true,
  },
];

export const FAIRNESS_RULES = [
  {
    icon: 'shield',
    title: 'Real Closed Silver Trades Only',
    desc: 'Standard Silver trades that are opened and properly closed count toward your volume. Instant hedging or fake volume gets filtered out.',
  },
  {
    icon: 'user-check',
    title: 'No Duplicate Accounts',
    desc: 'To keep it fair, only 1 verified real account per unique user is allowed to join the campaign.',
  },
  {
    icon: 'eye',
    title: 'Transparent Tracking',
    desc: 'The Weekly Lot Report is published every day so you can check your exact ranking and Silver lot counts transparently.',
  },
];

export const FAQS = [
  {
    q: 'Do I need to be an existing MBE client to join?',
    a: 'No. Both new and existing MBE Live Trading Account holders can join. Registration takes less than 60 seconds and is 100% free.',
  },
  {
    q: 'Which instrument counts toward the challenge?',
    a: 'Only Silver (XAGUSD) trades count. Other instruments will not contribute to your lot volume for this campaign.',
  },
  {
    q: 'When are the cash bonuses paid out?',
    a: 'Cash bonuses are auto credited to your MBE trading account as soon as you cross each Silver lot milestone. Weekly reporting keeps everything transparent.',
  },
  {
    q: 'What is included in the Bali trip?',
    a: 'Return flights from your home country plus 3 days and 2 nights stay at a luxury resort in Bali, Indonesia. Fully sponsored, guaranteed on hitting 30 Silver lots.',
  },
  {
    q: 'Is this a lucky draw or lottery?',
    a: 'Absolutely not. This is 100% performance based. Hit the Silver lot targets and the rewards unlock automatically. T&Cs apply.',
  },
];
